<div class="checklist_container">
  <checklist-detail
    *ngFor="let id of taskChecklistsIds$ | async"
    [checklist]="(taskChecklists$ | async)[id]"
    [editPermissions]="editPermissions"
  ></checklist-detail>
</div>
